import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import React, { useCallback, useEffect, useRef } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useGlobalFiscalYear } from '../../../../../../contexts/globalFiscalYearContext'
import { PeriodValue } from '../../../../../../types/periodValue'
import { getPeriodValueFromFiscalYear } from '../../../../../../utils/getPeriodValueFromFiscalYear'
import { defaultQuery, useInvoicesListFilters } from '../../hooks/useInvoicesListFilters'
import * as Styled from './styles'

export const InvoicesPeriodSelector = () => {
  const { organization } = useUserOrganization()
  const [{ period: queryParamPeriod }, setQueryParams] = useInvoicesListFilters()
  const { fiscalYear: globalFiscalYear } = useGlobalFiscalYear()
  const hasPeriodBeenSetRef = useRef(false)

  // Check the initial period
  useEffect(() => {
    if (!!organization?.id && !queryParamPeriod && globalFiscalYear !== undefined && !hasPeriodBeenSetRef.current) {
      hasPeriodBeenSetRef.current = true
      setQueryParams({ period: encodePeriodValue(getPeriodValueFromFiscalYear(globalFiscalYear), organization.id) })
    }
  }, [globalFiscalYear, organization, queryParamPeriod, setQueryParams])

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }

      setQueryParams({ period: encodePeriodValue(periodValue, organization.id), page: defaultQuery.page })
    },
    [organization, setQueryParams],
  )

  return (
    <Styled.InvoicesPeriodSelector>
      <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} placement="bottom-end" />
    </Styled.InvoicesPeriodSelector>
  )
}
